import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule, MatSnackBarModule, MatExpansionModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { FooterToolbarComponent } from './footer-toolbar/footer-toolbar.component';
import { LabelDrawerForEditComponent } from './label-drawer/label-drawer-for-edit/label-drawer-for-edit.component';
import { LabelDrawerForSelectComponent } from './label-drawer/label-drawer-for-select/label-drawer-for-select.component';
import { LabelDrawerComponent } from './label-drawer/label-drawer.component';
import { LabelSelectorModule } from './label-selector/label-selector.module';
import { RecordViewComponent } from './record-view.component';
import { TableModule } from './table/table.module';
import { ViewDrawerComponent } from './view-drawer/view-drawer.component';
import { ViewSelectorModule } from './view-selector/view-selector.module';
import { ViewDefineModule } from '../components/view-define/view-define.module';
import { LabelSelectModule } from '../components/label-select/label-select.module';
import { LabelManagerModule } from '../components/label-manager/label-manager.module';
import { ConditionalTemplateRunnerComponent } from './conditional-template-runner/conditional-template-runner.component';
import { CtRunnerInputComponent } from './conditional-template-runner/ct-runner-input/ct-runner-input.component';
import { CtRunnerSelectComponent } from './conditional-template-runner/ct-runner-select/ct-runner-select.component';
import { CtRunnerMultiSelectComponent } from './conditional-template-runner/ct-runner-multi-select/ct-runner-multi-select.component';
import { CtRunnerRangeInputComponent } from './conditional-template-runner/ct-runner-range-input/ct-runner-range-input.component';
import { CtRunnerSilderComponent } from './conditional-template-runner/ct-runner-silder/ct-runner-silder.component';
import { Ng5SliderModule } from 'ng5-slider';
// registerLoadedConfigEvent(CTRL_RECORDVIEW, () => getControllerRoutes(CTRL_RECORDVIEW, RecordViewComponent));
@NgModule({
	imports: [
		CommonModule,
		MatTooltipModule,
		MatMenuModule,
		MatIconModule,
		ClipboardModule,
		MatButtonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatDividerModule,
		MatInputModule,
		MatCheckboxModule,
		MatRippleModule,
		MatSidenavModule,
		MatChipsModule,
		MatTabsModule,
		MatDialogModule,
		DragDropModule,
		FormsModule,
		TableModule,
		MatCardModule,
		MatGridListModule,
		MatRadioModule,
		LabelSelectorModule,
		MatExpansionModule,
		ViewSelectorModule,
		MatSnackBarModule,
		ViewDefineModule,
		LabelSelectModule,
		LabelManagerModule,
		Ng5SliderModule
	],
	exports: [CommonModule, RecordViewComponent],
	declarations: [
		RecordViewComponent,
		FooterToolbarComponent,
		LabelDrawerComponent,
		LabelDrawerForSelectComponent,
		LabelDrawerForEditComponent,
		ViewDrawerComponent,
		ConditionalTemplateRunnerComponent,
		CtRunnerInputComponent,
		CtRunnerSelectComponent,
		CtRunnerMultiSelectComponent,
		CtRunnerRangeInputComponent,
		CtRunnerSilderComponent
	],
	schemas: [NO_ERRORS_SCHEMA]
})
export class RecordViewInnerModule {}
